import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-ticket-attachment',
  templateUrl: './ticket-attachment.component.html',
})
export class TicketAttachmentComponent {
  @Input() ticketAttachment: any;
  constructor() {}
}
